import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import socialApi from "../api/socialFeed";
import { useHospitalRealtime } from "./useHospitalRealtime";
import { SOCIAL_NOTIFICATION_EVENT_TYPES } from "../realtime/realtimeTypes";

export const SOCIAL_NOTIFICATIONS_CHANGED = "statdoctor:social-notifications-changed";

/** Unread social-activity count for badge on the Social nav tab (not shift/applicant bell). */
export function useSocialUnreadCount(enabled = true) {
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  const mountedRef = useRef(true);

  const onSocialRoute =
    location.pathname === "/social" || location.pathname.startsWith("/social/");

  const refresh = useCallback(() => {
    if (!enabled) return;
    socialApi.getSocialNotifications({
      params: { offset: 0, size: 1 },
      callback: (res: any) => {
        if (!mountedRef.current) return;
        const payload = res?.data ?? res?.response?.data;
        if (payload?.code === 200 || payload?.code === 0) {
          const data = payload?.data ?? payload;
          setUnreadCount(Number(data?.unreadCount ?? 0));
        }
      },
    });
  }, [enabled]);

  useEffect(() => {
    mountedRef.current = true;
    if (!enabled) return undefined;
    refresh();
    const onChanged = () => refresh();
    window.addEventListener(SOCIAL_NOTIFICATIONS_CHANGED, onChanged);
    return () => {
      mountedRef.current = false;
      window.removeEventListener(SOCIAL_NOTIFICATIONS_CHANGED, onChanged);
    };
  }, [enabled, refresh]);

  useHospitalRealtime({
    enabled,
    onInboxEvent: (event) => {
      const type = String(event.type || "");
      if (!SOCIAL_NOTIFICATION_EVENT_TYPES.has(type)) return;
      refresh();
      window.dispatchEvent(new Event(SOCIAL_NOTIFICATIONS_CHANGED));
    },
    onFallbackPoll: refresh,
  });

  const displayCount = onSocialRoute ? 0 : unreadCount;

  return { unreadCount: displayCount, refresh };
}
